<template>
    <div class="flex xl:justify-center font-roboto table-responsive">
        <table v-if="tableData && tableData.length > 0" class="w-full border-separate border-spacing-y-1">
            <thead>
                <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
                    <th v-for="(header, index) in tableHeaders" :key="header.title" @click="sortClicked(header)"
                        class="p-2 font-light text-[14px] 2xl:text-[16px] cursor-pointer" :class="{
                            'rounded-l-lg': index === 0,
                            'rounded-r-lg': index === tableHeaders.length - 1,
                            '!bg-[#BA90C6] text-white': true,
                        }">
                        <span class="flex items-center">
                            <span v-if="header.sort_applicable == '1'" class="max-h-5">
                                <button v-if="header.sort_direction == ''"
                                    class="p-0 border-0 focus:outline-none"></button>
                                <button v-else-if="header.sort_direction == 'ASC'"
                                    class="p-0 border-0 focus:outline-none">
                                    <img src="../../assets/images/asc.svg" alt="Sorting Ascending Arrow"
                                        class="w-4 h-4 object-contain">
                                </button>
                                <button v-else-if="header.sort_direction == 'DESC'"
                                    class="p-0 border-0 focus:outline-none">
                                    <img src="../../assets/images/desc.svg" alt="Sorting Descending Arrow"
                                        class="w-4 h-4 object-contain">
                                </button>
                            </span>
                            {{ header.title }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
                <tr v-for="(item, rowIndex) in tableData" :key="rowIndex"
                    class="mt-1 border-0 py-2 text-sm rounded-lg shadow-[0_0_10px_0_#00000026]">
                    <td v-for="(header, colIndex) in tableHeaders" :key="header.data_value" class="p-2 bg-white" :class="{
                        'rounded-l-lg': colIndex === 0,
                        'rounded-r-lg': colIndex === tableHeaders.length - 1,
                        'mobile:!min-w-[70px] tablet:min-w-auto': header.data_value === 'id',
                        'mobile:!min-w-[150px] tablet:min-w-auto': header.data_value === 'sro_number',
                        'mobile:!min-w-[200px] tablet:min-w-auto': header.data_value === 'plan_name',
                        'mobile:!min-w-[120px] tablet:min-w-auto': header.data_value === 'create_date',
                        'mobile:!min-w-[140px] tablet:min-w-auto': header.data_value === 'process_date',
                        'mobile:!min-w-[130px] tablet:min-w-auto': header.data_value === 'total_amount',
                    }">
                        <template v-if="header.data_value === 'create_date' || header.data_value === 'process_date'">
                            <span>
                                {{ item[header.data_value] != "-" ? $helper.formatDateTime(item[header.data_value]) : '-' }}
                            </span>
                        </template>
                        <template v-else-if="header.data_value === 'total_amount'">
                            ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}
                            <span class="text-[14px]">/{{
                                item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
                            }}</span>
                        </template>
                        <template v-else-if="header.data_value === 'status_slug'">
                            <span class="text-white rounded-md px-3 py-1 capitalize"
                                :style="{ backgroundColor: getStatusClass(item[header.data_value]) }">
                                {{ item[header.data_value] }}
                            </span>
                        </template>
                        <template v-else>
                            {{ item[header.data_value] }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-else class="mb-0 text-[16px] 2xl:text-[18px] text-center font-roboto w-full mt-3">No Record Found</p>
    </div>
</template>

<script>
export default {
    props: ["tableHeaders", "tableData", "sortClicked", "isLoading"],
    methods: {
        getStatusClass(status) {
            const statusClasses = {
                'approved': '#65B741',
                'pending': '#F39C12',
                'rejected': '#D7385E',
                'recieved': '#635985',
            };
            return statusClasses[status] || 'bg-gray-500';
        },
        // getTextStatusClass(textStatus) {
        //     const textStatusClasses = {
        //         'Evaluation Completed': 'text-cyan-500',
        //         'Inspection Started': 'text-blue-500',
        //     };
        //     return textStatusClasses[textStatus];
        // }
    }
};
</script>
